function CollapseView({ raw, onEdit, onView }) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>SKU:</strong> {raw?.sku}
        </p>
        <p className="mb-1">
          <strong>Item Name:</strong> {raw?.itemName}
        </p>
      </div>

      <div className="d-flex gap-2">
        <button className="btn btn-success text-white" onClick={onEdit}>
          <i className="bi bi-pencil-fill me-2"></i> Edit
        </button>
        {/* <button className="btn btn-danger" onClick={onDelete}>
          <i className="bi bi-trash-fill me-2"></i> View
        </button> */}
        <button
          className="btn "
          onClick={onView}
          style={{ backgroundColor: "#d1d1d1" }}
        >
          <i className="bi bi-eye me-2"></i> View
        </button>
      </div>
    </div>
  );
}

export default CollapseView;
